<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Детальная статистика</h4>
            <div class="sub-title">{{ this.date_from }} - {{ this.date_to }}</div>
          </div>
        </div>

        <TopBlock></TopBlock>
      </div>
    </div>
    <div class="filters d-flex mb-3">
      <MultiSelect v-if="resources.length"
                   v-model="selected_resource"
                   :options="resources"
                   :multi="true"
                   :only_value="true"
                   name="Площадки"></MultiSelect>
    </div>

    <div class="stats mb-3">
      <div class="stat" v-for="stat in stats" :style="{borderColor: total[stat].color}">
        <div class="name">{{ total[stat].name }}
          <popper v-if="total[stat].help" hover :content="total[stat].help">
            <i class="bi bi-info pointer"></i>
          </popper>
        </div>
        <div class="value" :style="{color: total[stat].color}">{{ total[stat].value }}</div>

      </div>
    </div>
    <div class="card mb-3">
      <div class="table-stat">
        <table class="table table-hover table-borderless table-sticky-header">
          <thead class="table-head sticky-top">

          <tr>
            <th>Площадка
              <popper hover content="При нажатии на конкретную площадку можно увидеть все к ней относящиеся ссылки">
                <i class="bi bi-info pointer"></i>
              </popper>
            </th>
            <th>Ссылок</th>
            <th>Рейтинг</th>
            <th>Отзывов</th>
            <th>С ответом</th>
            <th>Без ответа</th>
            <th>Позитив</th>
            <th>Негатив</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="resource in table_stat">
            <template v-if="!selected_resource.length || (selected_resource.indexOf(resource.resource.id)+1)">
              <tr style="cursor: pointer" @click.prevent="getLinks(resource)">
                <td class="pe-1 resource-name">
                  <div class="d-flex align-items-center">
                    <div class="resource me-2">
                  <span class="img" v-if="resource.resource.ico"
                        :style="{backgroundImage: `url(${ resource.resource.ico})`}"></span>
                      <span class="img no-image" v-else
                            :style="{backgroundColor: resource.resource.color + '20', color: resource.resource.color}">
              {{ $getShortName(resource.resource.name) }}
            </span>

                    </div>
                    <b class="name">{{ resource.resource?.name || resource.resource?.domain }}</b>
                  </div>
                </td>
                <td><b>{{ resource.links_count }}</b></td>
                <td><i class="bi bi-star-fill text-warning"></i>{{ resource.rating ? resource.rating.toFixed(2) : 0 }}
                </td>
                <td>{{ resource.review_count }}</td>
                <td>{{ resource.review_response }}</td>
                <td>{{ resource.review_count - resource.review_response }}</td>
                <td class="text-success">{{ resource.positives }}
                  ({{ resource.review_count ? (resource.positives / resource.review_count * 100).toFixed(0) : 0 }}%)
                </td>
                <td class="text-danger">{{ resource.negatives }}
                  ({{ resource.review_count ? (resource.negatives / resource.review_count * 100).toFixed(0) : 0 }}%)
                </td>

              </tr>
              <template v-if="resource.open">
                <tr v-for="link in resource.links" class="child-links">
                  <td class="pe-1 link">
                    <a class="name" :href="link.url" target="_blank" :title="link.url">
                      <template v-if="link.name || link.city || link.address">
                        {{ link.name || "" }}{{
                          link.name && (link.city || link.address) ? ", " : ""
                        }}{{ link.city || "" }}{{ link.city && link.address ? ", " : "" }}{{ link.address || "" }}
                      </template>
                      <template v-else>{{ link.url }}</template>
                    </a>
                  </td>
                  <td></td>
                  <td><i class="bi bi-star-fill text-warning"></i>{{ link.rating ? link.rating.toFixed(2) : 0 }}
                  </td>
                  <td>{{ link.review_count }}</td>
                  <td>{{ link.review_response }}</td>
                  <td>{{ link.review_count - link.review_response }}</td>
                  <td class="text-success">{{ link.positives }}
                    ({{ link.review_count ? (link.positives / link.review_count * 100).toFixed(0) : 0 }}%)
                  </td>
                  <td class="text-danger">{{ link.negatives }}
                    ({{ link.review_count ? (link.negatives / link.review_count * 100).toFixed(0) : 0 }}%)
                  </td>

                </tr>
              </template>
            </template>
          </template>
          </tbody>
          <tfoot v-if="total.review_count">
          <tr>
            <td colspan="2">
              <b>Итого</b>
            </td>
            <td><i class="bi bi-star-fill text-warning"></i>{{ total.rating.value }}</td>
            <td>{{ total.review_count.value }}</td>
            <td>{{ total.review_response.value }}</td>
            <td>{{ total.review_no_response.value }}</td>
            <td class="text-success">{{ total.positives_percent.value }}%</td>
            <td class="text-danger">{{ total.negatives_percent.value }}%</td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="mb-3">
      <RatingGraph name="Динамика рейтинга по площадкам"
                   :max_show="3"
                   active_interval_name="day"
      ></RatingGraph>
    </div>
    <div class="mb-3">
      <RatingGraph name="Динамика количества отзывов по площадкам"
                   :max_show="3"
                   active_interval_name="day"
                   metric="review_count"
                   :max_scale="null"
      ></RatingGraph>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <RatingGraphBar></RatingGraphBar>
      </div>
      <div class="col-lg-6">
        <ToneGraphBar></ToneGraphBar>
      </div>
    </div>
  </div>


</template>

<script>


import TopBlock from "@/components/TopBlock.vue";
import {ReviewApi} from "@/api/reviews";
import RatingGraph from "@/views/dictionary/review/components/RatingGraph.vue";
import RatingGraphBar from "@/views/dictionary/review/components/RatingGraphBar.vue";
import ToneGraphBar from "@/views/dictionary/review/components/ToneGraphBar.vue";
import datesMixin from "@/mixins/filterDates";
import {LinksApi} from "@/api/links";

export default {
  name: 'ProjectStat',
  data() {
    return {
      table_stat: [],
      selected_resource: [],
      resources: [],
      stats: ["rating", "review_count", "positives", "negatives", "review_response", "review_no_response"]
    }
  },
  components: {ToneGraphBar, RatingGraphBar, RatingGraph, TopBlock},
  mixins: [datesMixin],
  computed: {
    total() {
      let stats = {
        rating: {
          name: "Рейтинг",
          help: "Средний рейтинг по всем ссылкам, по которым ведется работа",
          color: 'var(--red)',
          value: 0
        },
        review_count: {
          name: "Всего отзывов",
          help: 'Количество отзывов, которое было собрано за весь период работы с начала первого сбора',
          color: 'var(--primary)',
          value: 0
        },
        review_response: {
          name: "С ответом",
          color: "var(--purple)",
          value: 0
        },
        review_no_response: {
          name: "Без ответа",
          color: "var(--orange)",
          value: 0
        },
        positives: {
          name: "Позитивные",
          color: 'var(--green)',
          value: 0
        },
        negatives: {
          name: "Негативные",
          color: "var(--red)",
          value: 0
        },
        positives_percent: {
          value: 0
        },
        negatives_percent: {
          value: 0
        },
      }
      let stat = this.table_stat;
      if (this.selected_resource.length) {
        stat = stat.filter(x => (this.selected_resource.indexOf(x.resource.id) + 1))
      }
      stat.forEach(x => {
        stats.rating.value += x.rating
        stats.review_count.value += x.review_count
        stats.review_response.value += x.review_response
        stats.review_no_response.value += (x.review_count - x.review_response)
        stats.positives.value += x.positives
        stats.negatives.value += x.negatives
      })
      stats.rating.value = stat.length ? (stats.rating.value / stat.length).toFixed(1) : 0;
      if (stats.rating.value >= 4) stats.rating.color = "var(--green)"
      else if (stats.rating.value >= 3) stats.rating.color = "var(--yellow)"
      stats.positives_percent.value = stats.review_count.value ? (stats.positives.value / stats.review_count.value * 100).toFixed(0) : 0
      stats.negatives_percent.value = stats.review_count.value ? (stats.negatives.value / stats.review_count.value * 100).toFixed(0) : 0
      return stats
    }
  },
  mounted: function () {
    LinksApi.review_domain_list().then(response => this.resources = response)
    this.getData();
  },
  methods: {
    getLinks(resource) {
      if (!resource.links) {
        const queryString = this.createQuery(resource.resource.id)

        ReviewApi.resource_links_stat(queryString).then(response => {
          resource.links = response
          resource.open = true
        })

      } else resource.open = !resource.open
    },
    createQuery(resource_id) {
      let filters = {}
      filters.start_date = this.date_from
      filters.end_date = this.date_to
      if (resource_id) filters.resource_id = resource_id
      filters.resource_ids = this.selected_resource
      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value === null || value === undefined) {
          continue;
        }

        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item !== null && item !== undefined && item !== '') {
              searchParams.append(key, item);
            }
          });
        } else if (value !== '') {
          searchParams.append(key, value);
        }
      }
      return searchParams.toString();
    },
    getData() {
      const queryString = this.createQuery()
      ReviewApi.full_stat(queryString).then(response => {
        this.table_stat = response
      })
    }
  }
}

</script>
<style scoped lang="scss">
.stats {
  display: flex;
  gap: 20px;

  .stat {
    padding: 15px;
    border-left-style: solid;
    border-left-width: 4px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: var(--shadow);
    flex: 1 1 auto;

    .name {
      color: var(--grey);
      font-size: 14px;
    }

    .value {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.child-links {
  .link {
    padding-left: 20px;

    .name {
      border-left: 1px solid #ccc;
      padding-left: 5px;
      white-space: wrap;
    }
  }
}

.table-stat {
  table {
    margin: 0;

    .resource-name {
      width: 50%;
    }

    .table-head {
      top: 70px;
    }

    tfoot {
      td {
        background: var(--soft-grey);
        border-radius: 0 0 5px 0;
      }
    }
  }
}

@media (width < 768px) {
  .stats {
    flex-wrap: wrap;
    gap: 10px;

    .stat {
      width: 120px;
    }
  }
}
</style>
